import { TERMS } from '../../../constants/terms';
import type { Condition } from '../../../hooks/useProductData';
import { getAmountRangeToString, getHumanizedMinValue } from '../../humanization';
import { plur } from '../../plur';

export const getDmsConditions = (item): Condition[] => {
  const conditions = [];

  // возраст, страховая сумма, цена

  // возраст
  const { ageMin, ageMax } = item;
  const ageValue = getAmountRangeToString({
    amountRange: {
      from: ageMin,
      to: ageMax,
    },
    isFloat: false,
    prefix: false,
    allowZero: true,
    defaultText: 'Любой',
  });

  conditions.push({
    value: `${ageValue} ${plur({ value: ageMax || ageMin, unit: TERMS.years })}`,
    description: 'Возраст',
  });

  // страховая сумма
  const { sumAll, sumAllTo } = item;
  const sumValue = getHumanizedMinValue({ from: sumAll, to: sumAllTo }, ' ₽', 'Без ограничений');

  conditions.push({
    value: sumValue,
    description: 'Страховая сумма',
    wide: true,
  });

  // цена
  const { price, priceTo } = item;

  const priceValue = getHumanizedMinValue(
    {
      from: price,
      to: priceTo,
      isFloat: false,
    },
    ' ₽ в год',
    '\u2014',
  );

  conditions.push({ value: priceValue, description: 'Цена', wide: true });

  return conditions;
};
